import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router } from "@angular/router";
import { BillingService } from "src/app/pages/billing/billing.service";
import { isUserOnboardingInProgress } from "src/app/pages/profile/profile.model";
import { ProfileService } from "src/app/pages/profile/profile.service";

/**
 * `/activate-service/billing` is the re-activation screen for a user whose
 * onboarding is already complete but whose billing lapsed (see
 * `userBillingGuard`). Guards against two invalid states:
 * - Onboarding still in progress → belongs in `/initial-setup/billing`.
 * - Billing already active → no need to be here; go to `returnUrl` or dashboard.
 */
export const activateServiceBillingGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const profileService = inject(ProfileService);
  const billingService = inject(BillingService);
  const router = inject(Router);

  if (isUserOnboardingInProgress(profileService.userProfile())) {
    return router.parseUrl("/initial-setup/billing");
  }

  if (billingService.hasActiveBillingCached()) {
    const returnUrl = route.queryParamMap.get("returnUrl");
    return router.parseUrl(returnUrl ?? "/dashboard");
  }

  return true;
};
